import { examinationURL } from "../../../utils/paths";
import { AsyncThunkConfig } from "../../../api/axiosConfig";
import { createAsyncThunk } from "@reduxjs/toolkit";
import instance, { ApiError, isAxiosError } from "../../../api/axiosConfig";
import { dispatchNotification } from "../../../utils/redux";
import { downloadFileFromArraybuffer } from "../../../utils/download";
import { getTimezoneOffset } from "../../../utils/timezone";

interface InterpretativeReportParams {
  examinationId: string;
  normSet: number;
  recipient: string;
  language: string;
}

export const downloadInterpretativeReport = createAsyncThunk<
  undefined,
  InterpretativeReportParams,
  AsyncThunkConfig
>(
  "documentation/reports/interpretative",
  async ({ examinationId, normSet, recipient, language }, thunkAPI) => {
    // Sprawdź czy parametry są prawidłowe
    if (!examinationId || String(examinationId) === "undefined") {
      return thunkAPI.rejectWithValue({
        message: "Nieprawidłowe parametry",
        results: null,
        error: true,
      } as ApiError);
    }

    try {
      const response = await instance.post<Blob>(
        `${examinationURL}${examinationId}/reports/interpretative/`,
        { normSet, recipient },
        {
          responseType: "arraybuffer",
          headers: {
            "Accept-Language": language,
            "X-Timezone-Offset": getTimezoneOffset().toString(),
          },
        }
      );

      downloadFileFromArraybuffer(response, "application/pdf");
    } catch (err) {
      if (isAxiosError(err) && err.response != null) {
        const extractedError = err.response.data as ApiError;

        dispatchNotification("error", extractedError.message);

        throw err;
      }

      dispatchNotification("error");
      throw err;
    }
  }
);